import { useNavigate, useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon, eyeIcon } from '../../../config/variables';
import { getMedia, hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { useTranslation } from 'react-i18next';

const VehicleModelsTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['models.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header: any, index: number) => (
          <span className={`head ${header.customClass}`} key={index}>
            {header.label}
          </span>
        ))}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item: any, index: number) => (
              <div
                className={`item has_big_logo ${hasEditPermission && 'clickable'} vehicles`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/vehicle-models/${id}/model-edit/${item.id}`, navigate);
                }}
              >
                <div className="column">
                  <div className="large-icon-container">{getMedia(item?.media, 'image') ? <img src={getMedia(item?.media, 'image')?.url} alt="" /> : '-'}</div>
                </div>
                <div className="column">
                  <div className="capitalize">{item?.name?.en || '-'}</div>
                </div>
                <div className="column">{item?.hidden ? t('yes') : t('no')}</div>
                {hasPermission(['variants.show']) && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/vehicle-models/${id}/model-variants/${item.id}`, navigate);
                      }}
                    >
                      {eyeIcon}
                    </div>
                  </div>
                )}
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/vehicle-models/${id}/model-edit/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default VehicleModelsTableContainer;
